export const LOCALES = ['fr', 'en'] as const
export type Locale = (typeof LOCALES)[number]
export const DEFAULT_LOCALE: Locale = 'fr'

export const toLocale = (value: string | null | undefined): Locale => {
  const short = (value ?? '').slice(0, 2).toLowerCase()
  return (LOCALES as readonly string[]).includes(short) ? (short as Locale) : DEFAULT_LOCALE
}
